import { EventIdentValues } from '@fullstory/proto/fs/api/segment';
import {
  DefinedEventRecord,
  NamedElementRecord,
} from '@fullstory/proto/fs/services/search-settings';
import { NodeType, NodeTypeToString } from '../components/JourneyMap/types';
import { int64 } from '@fullstory/proto/google/protobuf';
import { DefinedEventField } from '@fullstory/client-api';
import { OTHER_LABEL } from '@fullstory/library-ui';

export const getLabelForIdent = (
  ident: EventIdentValues,
  getPageNameById: (pageDefId: number) => string,
  getNamedElement: (elementId: string) => NamedElementRecord | undefined,
  getDefinedEvent: (definedEventId: string) => DefinedEventRecord | undefined,
) => {
  switch (ident.type) {
    case 'custom':
      return ident.values[0]?.stringValue ?? NodeTypeToString[NodeType.ApiEvent];
    case 'pageview':
      return getPageNameById(int64.toNumber(ident.values[0]?.longValue));
    case 'click':
      return ident.values[0]?.stringValue
        ? getNamedElement(ident.values[0]?.stringValue)?.namedElement?.name ?? ''
        : '';
    case 'seen':
      return ident.values[0]?.stringValue
        ? getNamedElement(ident.values[0]?.stringValue)?.namedElement?.name ?? ''
        : '';
    case DefinedEventField:
      return ident.values[0]?.stringValue
        ? getDefinedEvent(ident.values[0]?.stringValue)?.definedEvent?.name ?? ''
        : '';
    default:
      return OTHER_LABEL;
  }
};

export const getTypeForIdent = (ident: EventIdentValues) => {
  switch (ident.type) {
    case 'custom':
      return NodeType.ApiEvent;
    case 'pageview':
      return NodeType.Page;
    case 'click':
      return NodeType.ClickNamed;
    case 'seen':
      return NodeType.SeenNamed;
    case DefinedEventField:
      return NodeType.DefinedEvent;
    default:
      return NodeType.Other;
  }
};

export const getSublabelForIdent = (
  ident: EventIdentValues,
  customVars: { [key: string]: string } | undefined,
  pageVars: { [key: string]: string } | undefined,
  elemVars: { [key: string]: string } | undefined,
): [string, string] | null => {
  if (ident.type === 'custom' && customVars) {
    const label = ident.values[0]?.stringValue;
    if (label && customVars[label]) {
      return [generateVarLabel(customVars[label]), generateEventIdentValueLabel(ident)];
    }
  }
  if (ident.type === 'pageview' && pageVars) {
    const pageDefId = int64.toNumber(ident.values[0]?.longValue);
    if (pageVars[pageDefId]) {
      return [generateVarLabel(pageVars[pageDefId]), generateEventIdentValueLabel(ident)];
    }
  }
  if ((ident.type === 'click' || ident.type === 'seen') && elemVars) {
    const namedElementId = ident.values[0]?.stringValue;
    if (namedElementId && elemVars[namedElementId]) {
      return [generateVarLabel(elemVars[namedElementId]), generateEventIdentValueLabel(ident)];
    }
  }
  return null;
};

// Removes the trailing `_${varType}` for labeling in the Journeys UI
export function generateVarLabel(varString: string | undefined): string {
  return varString?.split(/_[^_]*$/gm)[0] ?? '';
}

export function generateEventIdentValueLabel(identity: EventIdentValues): string {
  return identity.values[1]?.stringValue ?? identity.values[1]?.longValue?.toString() ?? '';
}
